const templateFree = {
    namespaced: true,
    state: {
        selectedItem: null, // 模板素材选中、素材替换通过当前选中的对象来操作
        editingTextKey: '',
        isCtrlKeyDown: false,
        selectedLayers: [],
        resizing: false,
        recentTextStyle: { // 记录刚才操作的文本样式，新增文本图层时直接复用样式
            fontFamily: null,
            fontSize: null,
            color: null,
            lineHeight: null
        }
    },
    getters: {
        groupMergeVisible(state){
            let layers = state.selectedLayers || [];
            if(layers.length === 0){
                return false;
            }
            if(layers.length > 1){
                return true;
            }
            let firstItem = layers[0];
            if(firstItem.type === 'group' || firstItem.parentGroupId){
                return false;
            }
            return true;
        }
    },
    mutations: {
        set_selected_item(state, item) {
            state.selectedItem = item;
        },
        set_editing_text_key(state, key){
            state.editingTextKey = key;
        },
        set_selected_layers(state, items){
            state.selectedLayers = items;
        },
        set_ctrl_key(state, trueOrFalse){
            state.isCtrlKeyDown = trueOrFalse;
        },
        set_resizing(state, trueOrFalse){
            state.resizing = trueOrFalse;
        },
        set_recent_text_style(state, attrObj){
            Object.assign(state.recentTextStyle, attrObj);
        }
    },
    actions: {}
}
export default templateFree;
